import { CalibrationMinimizedController } from "./CalibrationMinimizedController.svelte"

export const openMinimizedCalibration = CalibrationMinimizedController.open
export const hideMinimizedCalibration = CalibrationMinimizedController.hide
